<template>
  <div style="margin: 20px">
    <h1>Страница подтверждения</h1>
    <div v-if="isAdmin">
      <div v-if="loading">
        <p>Загрузка...</p>
      </div>
      <div v-else-if="confirmationMessage">
        <p v-html="confirmationMessage"></p>
      </div>
    </div>
    <div v-else>
      <p>Вам нужно авторизоваться как администратор, чтобы получить доступ к этой странице.</p>
    </div>
  </div>
</template>

<script>
import axiosClient from "@/axios";

export default {
  data() {
    return {
      loading: true,
      confirmationMessage: ''
    }
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('isAdmin') === 'true';
    }
  },
  created() {
    if (this.isAdmin) {
      this.sendConfirmationRequest();
    } else {
      this.loading = false;
    }
  },
  methods: {
    async sendConfirmationRequest() {
      try {
        const uuid = this.$route.params.uuid;
        const response = await axiosClient.post('/opera_2024/confirm', { uuid: uuid });
        if (response.data.alreadyConfirmed) {
          this.confirmationMessage = `<span style="color:red">Вы уже прошли проверку</span><br/>Сектор: ${response.data.sector} Ряд: ${response.data.row} Номер места: ${response.data.seat_number}`;
        } else {
          this.confirmationMessage = `<span  style="color:green">Подтверждено!</span><br/>Сектор: ${response.data.sector} Ряд: ${response.data.row} Номер места: ${response.data.seat_number}`;
        }
      } catch (error) {
        console.error('Ошибка подтверждения', error);
        this.confirmationMessage = 'Ошибка подтверждения QR-кода' + error;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
